export default {
  normal: {
    leftClick: 'Left Button',
    middleClick: 'Middle Button',
    rightClick: 'Right Button',
    dpiInc: 'DPI+',
    dpiDec: 'DPI-',
    forward: 'Forward',
    back: 'Back',
    wheelForward: 'Wheel Forward',
    wheelBackward: 'Wheel Backward',
    wheelLeft: 'Wheel Left',
    wheelRight: 'Wheel Right',
    diy: 'DIY Key',
    fireButton: 'Fire Button',
    sniperButton: 'Sniper Button',
    dpiCycleInc: 'DPI Cycle+',
    dpiCycleDec: 'DPI Cycle-',
    configCycle: 'Config Switch',
    dongleCycle: 'Dongle Switch',
    disableKey: 'Disable Key',
  },
  combinedKey: {
    apply: 'Apply',
    description: 'Combine any keys from the right keyboard, up to 3 keys',
    key1: 'Key 1',
    key2: 'Key 2',
    key3: 'Key 3',
  },
  tabs: {
    normal: 'Normal',
    media: 'Media',
    config: 'Config',
    macro: 'Macro',
    keyboardKeys: 'Keyboard Keys',
    combinedKeys: 'Combined Keys',
    advanced: 'Advanced Remap',
  },
  layers: {
    winDefault: 'Win Default Layer',
    winFn: 'Win Fn Layer',
    macDefault: 'Mac Default Layer',
    macFn: 'Mac Fn Layer',
  },
  advancedTypes: {
    RS: 'RS',
    SOCD: 'SOCD',
  },
  advanced: {
    bindingList: 'Binding List',
    create: 'New Advanced Key',
    empty: 'No advanced keys yet. Click New Advanced Key to add one.',
    selectFunction: 'Select Function',
    bindHint: 'Click a key above or press a physical key to bind',
    modes: {
      mt: {
        title: 'Hold/Tap (MT)',
        excerpt: 'One key can trigger different actions for tap and hold',
      },
      tgl: {
        title: 'Toggle (TGL)',
        excerpt: 'Tap to toggle continuous trigger; hold for a normal press',
      },
      rs: {
        title: 'Rapid Snap (RS)',
        excerpt: 'When two keys are pressed together, the deeper press wins',
      },
      socd: {
        title: 'Instant Release (SOCD)',
        excerpt: 'When two keys are pressed together, trigger the preset key quickly',
      },
      dks: {
        title: 'Dynamic Keystroke (DKS)',
        excerpt: 'Bind 1 to 4 actions to one key based on press and release depth',
      },
    },
    deleteDialog: {
      title: 'Delete Advanced Key',
      content:
        'Delete this advanced key binding? It cannot be restored and must be added again afterward.',
    },
  },
  videoCarousel: {
    instruction:
      'Click a virtual key above and then choose a character on the right, or drag a character from the right onto the virtual key above.',
  },
  targetPanel: {
    restoreKey: 'Restore Key',
    restoreFactoryDefault: 'Restore Factory Default',
    currentFactoryDefault: 'Currently factory default',
    factoryDefaultKey: 'Factory default: {label}',
    originalKey: 'Original key: {label}',
    mtTooltip: 'Tap:{click}/Hold:{press}',
    tglTooltip: 'Tap:{click}',
    dksTooltip: 'Keys: {keys}',
    macroFallback: 'Macro',
    // V700diy-87 three lighting function keys
    v700BacklightMode: 'Backlight Mode',
    v700SideLightMode: 'Side Light Mode',
    v700BacklightBrightness: 'Backlight Brightness',
  },
  media: {
    prevTrack: 'Previous Track',
    playPause: 'Play/Pause',
    nextTrack: 'Next Track',
    stop: 'Stop',
    mute: 'Mute',
    volumeUp: 'Volume+',
    volumeDown: 'Volume-',
    player: 'Media Player',
    mail: 'Mail',
    home: 'Home',
    calculator: 'Calculator',
    myComputer: 'My Computer',
    search: 'Search',
    browserBack: 'Back (Browser)',
    browserForward: 'Forward (Browser)',
    browserRefresh: 'Refresh (Browser)',
    browserFavorites: 'Favorites (Browser)',
    systemPower: 'Power Off',
    systemSleep: 'Sleep',
    brightnessUp: 'Brightness+',
    brightnessDown: 'Brightness-',
    keyboardBrightnessUp: 'Increase Keyboard Brightness',
    keyboardBrightnessDown: 'Decrease Keyboard Brightness',
    mouseLeft: 'Mouse Left Button',
    mouseRight: 'Mouse Right Button',
    mouseMiddle: 'Mouse Middle Button',
    mouseForward: 'Mouse Forward Button',
    mouseBack: 'Mouse Back Button',
    togLed: 'TOG LED',
    scrollLock: 'Scroll',
    pauseBreak: 'Pause',
    keyHome: 'Home',
    keyEnd: 'End',
    ledColor: 'LED Color',
    winLock: 'WIN Lock',
    ledModeUp: 'LED Mode+',
    ledModeDown: 'LED Mode-',
    ledSpeedUp: 'LED Speed+',
    ledSpeedDown: 'LED Speed-',
    sideLedMode: 'Side LED Mode',
    sideLedColor: 'Side LED Color',
    closeWindow: 'Close Window',
    lockComputer: 'Lock Computer',
    application: 'Application',
    showDesktop: 'Show Desktop',
    zoomInScreen: 'Zoom In',
    zoomOutScreen: 'Zoom Out',
    copy: 'Copy',
    paste: 'Paste',
    cut: 'Cut',
    selectAll: 'Select All',
  },
  config: {
    quickSwitchConfig: 'Quick Config Switch',
    quickConfigFile: 'Quick Config Files',
    conflictTip:
      'This feature may conflict with "Automatically switch config files with games and apps". Use it with caution.',
    suggestionTip:
      'Use the same shortcut for this feature across multiple configs so you can still switch back after changing from Config A to Config B.',
    prevConfig: 'Previous Config',
    nextConfig: 'Next Config',
    profile: 'Profile',
  },
  mt: {
    apply: 'Apply',
    click: 'Tap',
    longPress: 'Hold',
    triggerTime: 'Normal trigger hold time',
    description: 'Tap triggers one key, hold triggers another key',
    guide: 'Drag or click a key from the left side and add it to the function box above first',
  },
  tgl: {
    apply: 'Apply',
    sustainedTrigger: 'Toggle Switch/Continuous Trigger',
    holdTime: 'Normal trigger hold time',
    description: 'Tap to toggle continuous triggering, hold for normal behavior',
    guide: 'Drag or click a key from the left side and add it to the function box above first',
  },
  dks: {
    intro: 'Based on press and release depth, one key can trigger up to four functions',
    apply: 'Apply',
    applyToast: 'Click "Apply" to finish assigning the DKS function',
  },
  rs: {
    title: 'RS Key Binding',
    apply: 'Apply',
    key1: 'Key 1',
    key2: 'Key 2',
    quickTrigger: 'Rapid Trigger',
    quickTriggerDescription:
      'When enabled, it works together with RT. You can go to the travel page to adjust RT sensitivity.',
    executePoint: 'Actuation Point',
    executePointDescription:
      'Set an actuation point for the two bound keys. After both keys reach the actuation height, the RS function takes effect. The key closer to bottom-out triggers first while the other is released. If both bottom out completely, both keys trigger at the same time.',
  },
  socd: {
    title: 'SOCD Key Binding',
    apply: 'Apply',
    key1: 'Key 1',
    key2: 'Key 2',
    quickTrigger: 'Rapid Trigger',
    quickTriggerDescription: 'Works with RT mode. Adjust sensitivity in the Actuation page.',
    executePoint: 'Actuation Point Settings',
    bottomTrigger: 'Both keys trigger at full press.',
    executePointDescription:
      'Set the actuation point for both keys. SOCD activates when both keys reach this point.',
    methods: {
      rearCover: {
        title: 'Last Input Priority',
        excerpt:
          'The latest key press takes priority. The previous key must fully release before triggering again.',
      },
      absolutePriority: {
        title: 'Absolute Priority',
        excerpt:
          'Set one key as the priority key. It always triggers regardless of the other key’s state.',
      },
      conflict: {
        title: 'Neutral',
        excerpt:
          'Both keys are disabled when pressed together. The remaining key triggers after one key is released.',
      },
    },
  },
  macro: {
    label: 'Macro',
    rightClickEdit: 'Right Click Edit',
    addTip: 'Create new one or click the "Start Recording" button',
    buttons: {
      import: 'Import',
      export: 'Export',
      locate: 'Locate current macro',
      cancelSelection: 'Cancel Selection',
      create: 'New',
      cancel: 'Cancel',
      delete: 'Delete',
      tip: 'Some online games may classify the use of hotkeys or macros as cheating, risking account suspension.',
    },
    deleteDialog: {
      title: 'Delete Macro File',
      content: 'Delete this macro file? It cannot be restored and must be added again afterward.',
    },
    toolbar: {
      loopCount: 'Repeat',
      togglePlayback: 'Toggle With Assigned Key',
      playOnPress: 'Play While Pressed',
      startRecording: 'Start Recording',
      input: 'Custom',
      delaySet: 'Delay',
      delaySetContent: 'Apply the same delay to all events. Minimum delay: 2 ms.',
    },
    menu: {
      key: 'Key',
      delay: 'Delay',
      coordinate: 'Coordinate',
    },
    wheel: {
      forward: 'Wheel Up',
      backward: 'Wheel Down',
      left: 'Wheel Left',
      right: 'Wheel Right',
    },
  },
}
